function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { generateMenu, AdaptiveListener } from 'xps-react-utils';
import UtilityBar from '../UtilityBar';
import HeaderBar from '../HeaderBar';
import NavBar from '../NavBar';
import AppBar from '../AppBar';
import Logo from '../Logo';
import NavDrawer from '../NavDrawer';

require('xps-style/core/header.css');

var Header = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMobileSize", function () {
      return _this.updateSize('mobile');
    });

    _defineProperty(_assertThisInitialized(_this), "onTabletSize", function () {
      return _this.updateSize('tablet');
    });

    _defineProperty(_assertThisInitialized(_this), "onDesktopSize", function () {
      return _this.updateSize('desktop');
    });

    _defineProperty(_assertThisInitialized(_this), "updateSize", function (size) {
      var headerType = _this.props.headerType;
      var updatedSize = headerType || size;
      return _this.setState({
        size: updatedSize
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleNavDrawer", function () {
      var onNavDrawerClose = _this.props.onNavDrawerClose;
      var isNavDrawerOpen = _this.state.isNavDrawerOpen;

      if (isNavDrawerOpen && onNavDrawerClose) {
        onNavDrawerClose();
      } else {
        _this.setState({
          isNavDrawerOpen: !isNavDrawerOpen
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "AdaptiveHeader", function () {
      var _this$props = _this.props,
          utilityLinks = _this$props.utilityLinks,
          headerLinks = _this$props.headerLinks,
          navLinks = _this$props.navLinks,
          mobileLinks = _this$props.mobileLinks,
          appTitle = _this$props.appTitle,
          SecondaryTitleComponent = _this$props.SecondaryTitleComponent,
          appMenuComponent = _this$props.appMenuComponent,
          accountMenuComponent = _this$props.accountMenuComponent,
          contentComponent = _this$props.contentComponent,
          className = _this$props.className,
          logo = _this$props.logo,
          logoType = _this$props.logoType,
          theme = _this$props.theme,
          navTheme = _this$props.navTheme,
          height = _this$props.height,
          displayUtilityBar = _this$props.displayUtilityBar,
          fullWidth = _this$props.fullWidth,
          NavBarContentComponent = _this$props.NavBarContentComponent,
          NavDrawerContentComponent = _this$props.NavDrawerContentComponent,
          NavDrawerLogo = _this$props.NavDrawerLogo,
          useDesktopHeaderOnTablet = _this$props.useDesktopHeaderOnTablet,
          TabletHeaderComponent = _this$props.TabletHeaderComponent,
          MobileHeaderComponent = _this$props.MobileHeaderComponent,
          location = _this$props.location;
      var _this$state = _this.state,
          isNavDrawerOpen = _this$state.isNavDrawerOpen,
          size = _this$state.size;

      var mobileHeaderNavLinks = function () {
        if (mobileLinks) return generateMenu(mobileLinks);
        return [navLinks !== undefined && generateMenu(navLinks), headerLinks !== undefined && headerLinks, utilityLinks !== undefined && utilityLinks];
      }();

      var renderLogo = function renderLogo() {
        if (logo) {
          return logo();
        } else {
          return /*#__PURE__*/React.createElement(Logo, {
            color: "white",
            logoType: logoType,
            height: 56
          });
        }
      };

      var screenSizeFromState = size;

      if (size === 'mobile') {
        return /*#__PURE__*/React.createElement(React.Fragment, null, MobileHeaderComponent ? MobileHeaderComponent() : /*#__PURE__*/React.createElement("div", {
          className: "height-xl"
        }, /*#__PURE__*/React.createElement(AppBar, {
          theme: theme,
          titleId: "mobileheader",
          title: /*#__PURE__*/React.createElement("div", null, renderLogo),
          navIcon: "menu",
          navOnClick: _this.toggleNavDrawer,
          actionItems: function actionItems() {
            return contentComponent(screenSizeFromState);
          }
        })), /*#__PURE__*/React.createElement(NavDrawer, {
          data: mobileHeaderNavLinks,
          theme: theme,
          logo: NavDrawerLogo,
          NavDrawerContentComponent: NavDrawerContentComponent,
          isOpen: isNavDrawerOpen,
          handleDrawerToggle: _this.toggleNavDrawer
        }));
      } else if (size === 'tablet' && !useDesktopHeaderOnTablet) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, TabletHeaderComponent ? TabletHeaderComponent() : /*#__PURE__*/React.createElement("div", {
          className: "height-xl"
        }, /*#__PURE__*/React.createElement(AppBar, {
          theme: theme,
          titleId: "tabletheader",
          title: /*#__PURE__*/React.createElement("div", null, renderLogo),
          navIcon: "menu",
          navOnClick: _this.toggleNavDrawer,
          actionItems: function actionItems() {
            return contentComponent(screenSizeFromState);
          }
        })), /*#__PURE__*/React.createElement(NavDrawer, {
          data: mobileHeaderNavLinks,
          theme: theme,
          logo: NavDrawerLogo,
          NavDrawerContentComponent: NavDrawerContentComponent,
          isOpen: isNavDrawerOpen,
          handleDrawerToggle: _this.toggleNavDrawer
        }));
      } else {
        return /*#__PURE__*/React.createElement(React.Fragment, null, displayUtilityBar && /*#__PURE__*/React.createElement(UtilityBar, {
          appTitle: appTitle,
          links: utilityLinks,
          appMenu: appMenuComponent,
          accountMenu: accountMenuComponent,
          theme: theme
        }), /*#__PURE__*/React.createElement(HeaderBar, {
          className: className,
          theme: theme,
          logo: logo,
          logoType: logoType,
          appTitle: displayUtilityBar ? null : appTitle,
          SecondaryTitleComponent: SecondaryTitleComponent,
          content: function content() {
            return contentComponent(screenSizeFromState);
          },
          links: headerLinks,
          height: height,
          fullWidth: fullWidth
        }), navLinks && /*#__PURE__*/React.createElement(NavBar, {
          theme: navTheme,
          links: generateMenu(navLinks),
          fullWidth: fullWidth,
          contentComponent: NavBarContentComponent,
          location: location
        }));
      }
    });

    var openMobileNavDrawer = _this.props.openMobileNavDrawer;
    _this.state = {
      isNavDrawerOpen: openMobileNavDrawer
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var openMobileNavDrawer = this.props.openMobileNavDrawer;
      var isNavDrawerOpen = this.state.isNavDrawerOpen;

      if (openMobileNavDrawer !== prevProps.openMobileNavDrawer) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isNavDrawerOpen: !isNavDrawerOpen
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AdaptiveListener, {
        onMobileSize: this.onMobileSize,
        onTabletSize: this.onTabletSize,
        onDesktopSize: this.onDesktopSize
      }, /*#__PURE__*/React.createElement(this.AdaptiveHeader, null));
    }
  }]);

  return Header;
}(React.Component);

_defineProperty(Header, "propTypes", {
  /** Application title or name */
  appTitle: PropTypes.string,

  /** Custom component displayed next to the app title in the Header Bar */
  SecondaryTitleComponent: PropTypes.func,

  /** Toggle displaying UtilityBar component. Default is false */
  displayUtilityBar: PropTypes.bool,

  /** Set the header to full width according to the grid system */
  fullWidth: PropTypes.bool,

  /** Set height of the Header bar. Minimum allowable height is 72px */
  height: PropTypes.number,

  /** Array of links for the utility bar. 'displayUtilityBar' has to be set to true to use this */
  utilityLinks: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  /** Links array that floats right within HeaderBar */
  headerLinks: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  /** Links object/array for Navigation menu. See Navigation Data Structure for more details. */
  navLinks: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  mobileLinks: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string,

  /** You can insert your custom component here within the Utility Bar, e.g. App Menu component */
  appMenuComponent: PropTypes.func,

  /** You can insert your custom component here within the Utility Bar, e.g. Account Menu component */
  accountMenuComponent: PropTypes.func,
  contentComponent: PropTypes.func,
  logo: PropTypes.func,

  /** Select logo type: single, double, centered */
  logoType: PropTypes.oneOf(['single', 'double', 'centered']),

  /** Select dark or light theme for Header */
  theme: PropTypes.oneOf(['dark', 'light']),

  /** Select dark or light theme for Nav bar (optional) */
  navTheme: PropTypes.oneOf(['dark', 'light']),

  /** Set true to use desktop header on tablet size. Default is false (using mobile header on tablet size) */
  useDesktopHeaderOnTablet: PropTypes.bool,
  NavBarContentComponent: PropTypes.func,

  /** Custom component in the NavDrawer component to be displayed below the menu links, or placed anywhere with position absolute (e.g. Sign Out button) */
  NavDrawerContentComponent: PropTypes.func,

  /** Custom logo for NavDrawer */
  NavDrawerLogo: PropTypes.func,

  /** Select mobile, tablet or desktop header type (optional) */
  headerType: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),

  /** Custom component for tablet header */
  TabletHeaderComponent: PropTypes.func,

  /** Custom component for mobile header / drawer */
  MobileHeaderComponent: PropTypes.func,

  /** set to true to open mobile NavDrawer from outside the Header component */
  openMobileNavDrawer: PropTypes.bool,

  /** callback function for closing NavDrawer */
  onNavDrawerClose: PropTypes.func,

  /** If using a router-dom package, Wrap the Header component with the 'withRouter' method to improve Navigation highlighting */
  location: PropTypes.object
});

_defineProperty(Header, "defaultProps", {
  height: 72,
  logoType: 'double',
  displayUtilityBar: false,
  contentComponent: function contentComponent() {},
  useDesktopHeaderOnTablet: false,
  fullWidth: true
});

export { Header as default };
Header.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onMobileSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onTabletSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDesktopSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "updateSize",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "size",
      "type": null
    }],
    "returns": null
  }, {
    "name": "toggleNavDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "AdaptiveHeader",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Header",
  "props": {
    "height": {
      "defaultValue": {
        "value": "72",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Set height of the Header bar. Minimum allowable height is 72px"
    },
    "logoType": {
      "defaultValue": {
        "value": "'double'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'single'",
          "computed": false
        }, {
          "value": "'double'",
          "computed": false
        }, {
          "value": "'centered'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Select logo type: single, double, centered"
    },
    "displayUtilityBar": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Toggle displaying UtilityBar component. Default is false"
    },
    "contentComponent": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "useDesktopHeaderOnTablet": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set true to use desktop header on tablet size. Default is false (using mobile header on tablet size)"
    },
    "fullWidth": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set the header to full width according to the grid system"
    },
    "appTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Application title or name"
    },
    "SecondaryTitleComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom component displayed next to the app title in the Header Bar"
    },
    "utilityLinks": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": "Array of links for the utility bar. 'displayUtilityBar' has to be set to true to use this"
    },
    "headerLinks": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": "Links array that floats right within HeaderBar"
    },
    "navLinks": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": "Links object/array for Navigation menu. See Navigation Data Structure for more details."
    },
    "mobileLinks": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "appMenuComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "You can insert your custom component here within the Utility Bar, e.g. App Menu component"
    },
    "accountMenuComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "You can insert your custom component here within the Utility Bar, e.g. Account Menu component"
    },
    "logo": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "theme": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'dark'",
          "computed": false
        }, {
          "value": "'light'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Select dark or light theme for Header"
    },
    "navTheme": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'dark'",
          "computed": false
        }, {
          "value": "'light'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Select dark or light theme for Nav bar (optional)"
    },
    "NavBarContentComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "NavDrawerContentComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom component in the NavDrawer component to be displayed below the menu links, or placed anywhere with position absolute (e.g. Sign Out button)"
    },
    "NavDrawerLogo": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom logo for NavDrawer"
    },
    "headerType": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'mobile'",
          "computed": false
        }, {
          "value": "'tablet'",
          "computed": false
        }, {
          "value": "'desktop'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Select mobile, tablet or desktop header type (optional)"
    },
    "TabletHeaderComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom component for tablet header"
    },
    "MobileHeaderComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom component for mobile header / drawer"
    },
    "openMobileNavDrawer": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "set to true to open mobile NavDrawer from outside the Header component"
    },
    "onNavDrawerClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "callback function for closing NavDrawer"
    },
    "location": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "If using a router-dom package, Wrap the Header component with the 'withRouter' method to improve Navigation highlighting"
    }
  }
};